import { render } from "./HelpMenu.vue?vue&type=template&id=53628faf"
import script from "./HelpMenu.vue?vue&type=script&lang=ts"
export * from "./HelpMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script